import { UserSessionService } from './../../UserSession/user-session.service';

import { Component, Input, OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { CompanyService } from '../../apiclient';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

/**
 * Componente que renderiza la columna de Acciones de la tabla de informes
 */
@Component({
  templateUrl: './informes.actions.cell.component.html',
})
export class InformesActionsCellComponent implements ViewCell, OnInit, OnDestroy {
  mySubscription: any;
  renderValue: string;
  reportid: string;
  tipoInforme: string;
  @Input() value: string | number;
  @Input() rowData: any;

  /**
   * @ignore
   */
  ngOnInit() {


    this.renderValue = this.value.toString().toUpperCase();
    this.reportid = this.rowData.id;
    this.tipoInforme = this.rowData.tipoInforme;

  }

  constructor(private dialogService: NbDialogService,private userSessionService : UserSessionService,
     private companyService: CompanyService,private router: Router) {
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };

      this.mySubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // Trick the Router into believing it's last link wasn't previously loaded
          this.router.navigated = false;
        }
      });
  }


  /**
   * @ignore
   */
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

}
